var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 15.7778C15.7778 16.9437 14.8326 17.8889 13.6667 17.8889C12.5007 17.8889 11.5556 16.9437 11.5556 15.7778C11.5556 14.6118 12.5007 13.6667 13.6667 13.6667C14.8326 13.6667 15.7778 14.6118 15.7778 15.7778Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4444 15.7778C28.4444 16.9437 27.4993 17.8889 26.3333 17.8889C25.1674 17.8889 24.2222 16.9437 24.2222 15.7778C24.2222 14.6118 25.1674 13.6667 26.3333 13.6667C27.4993 13.6667 28.4444 14.6118 28.4444 15.7778Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9959 27.1313C12.8865 27.9025 14.1047 28.4945 15.485 28.8929C16.8737 29.2938 18.4293 29.5 20 29.5C21.5707 29.5 23.1263 29.2938 24.515 28.8929C25.8953 28.4945 27.1135 27.9025 28.0041 27.1313M39 20C39 30.4934 30.4934 39 20 39C9.50659 39 1 30.4934 1 20C1 9.50659 9.50659 1 20 1C30.4934 1 39 9.50659 39 20ZM15.7778 15.7778C15.7778 16.9437 14.8326 17.8889 13.6667 17.8889C12.5007 17.8889 11.5556 16.9437 11.5556 15.7778C11.5556 14.6118 12.5007 13.6667 13.6667 13.6667C14.8326 13.6667 15.7778 14.6118 15.7778 15.7778ZM28.4444 15.7778C28.4444 16.9437 27.4993 17.8889 26.3333 17.8889C25.1674 17.8889 24.2222 16.9437 24.2222 15.7778C24.2222 14.6118 25.1674 13.6667 26.3333 13.6667C27.4993 13.6667 28.4444 14.6118 28.4444 15.7778Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEmoji);
export default __webpack_public_path__ + "static/media/icone_emoji.0b78275886324193ff28976b1bcb0006.svg";
export { ForwardRef as ReactComponent };